var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "#F2F0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "#FCFCFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.81348,
    y: 40.4355,
    width: 30.9375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.81348,
    y: 40.4355,
    width: 30.9375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 29.1855,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 29.1855,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 17.375,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 17.375,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 6.125,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 6.125,
    width: 44.4375,
    height: 5.625,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23.0625,
    height: 22.5,
    fill: "#0052B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0615 19.3467L17.374 20.1904L17.9365 18.5029L16.8115 17.3779H18.499L19.0615 15.6904L19.9053 17.3779H21.3115L20.1865 18.5029L20.749 20.1904L19.0615 19.3467Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 19.3467L9.5 20.1904L10.0625 18.5029L8.9375 17.3779H10.625L11.1875 15.6904L12.0313 17.3779H13.4375L12.3125 18.5029L12.875 20.1904L11.1875 19.3467Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 19.3467L1.625 20.1904L2.1875 18.5029L1.0625 17.3779H2.75L3.3125 15.6904L4.15625 17.3779H5.5625L4.4375 18.5029L5 20.1904L3.3125 19.3467Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0615 13.1543L17.374 13.998L17.9365 12.3105L16.8115 11.1855H18.499L19.0615 9.49805L19.9053 11.1855H21.3115L20.1865 12.3105L20.749 13.998L19.0615 13.1543Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0615 6.96875L17.374 7.8125L17.9365 6.125L16.8115 5H18.499L19.0615 3.3125L19.9053 5H21.3115L20.1865 6.125L20.749 7.8125L19.0615 6.96875Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0615 0.783205L17.374 1.62696L17.9365 -0.0605454L16.8115 -1.18555H18.499L19.0615 -2.87305L19.9053 -1.18555H21.3115L20.1865 -0.0605454L20.749 1.62696L19.0615 0.783205Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 6.96875L9.5 7.8125L10.0625 6.125L8.9375 5H10.625L11.1875 3.3125L12.0313 5H13.4375L12.3125 6.125L12.875 7.8125L11.1875 6.96875Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 13.1543L9.5 13.998L10.0625 12.3105L8.9375 11.1855H10.625L11.1875 9.49805L12.0313 11.1855H13.4375L12.3125 12.3105L12.875 13.998L11.1875 13.1543Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 13.1543L1.625 13.998L2.1875 12.3105L1.0625 11.1855H2.75L3.3125 9.49805L4.15625 11.1855H5.5625L4.4375 12.3105L5 13.998L3.3125 13.1543Z",
    fill: "#EFEFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEua);
export default __webpack_public_path__ + "static/media/eua.c206700c16fa9892e1516d2a23a0f75a.svg";
export { ForwardRef as ReactComponent };